"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("rxjs-compat/add/operator/share");
//# sourceMappingURL=share.js.map